module.exports = __webpack_public_path__ + "static/media/logo-white.eb3742eb.svg";